import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "updateAlumniComplete",
  tabindex: "-1",
  "aria-labelledby": "updateAlumniComplete",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-md" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "text-center my-4" }
const _hoisted_7 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_8 = { class: "d-flex justify-content-center w-100" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { PATH } from '@/constants'
import { getCookie } from '@/utils'
import { useRoute, useRouter } from 'vue-router'
import { onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const path = route.path.split('/')[1]
const redirect = getCookie(`${PATH[`${path}`].path}-redirect-path`)
const hasForceLogout = 'two_factor_enabled' in route.query || 'invited_code' in route.query
onMounted(() => {
  const modalEl = document.getElementById('updateAlumniComplete')

  if (modalEl) {
    modalEl.addEventListener('hide.bs.modal', () => {
      forceLogout()
    })
  }
})
function getCodeFromUrl(path: string): string | null {
  const query = path?.split('?')[1]
  if (!query) return null

  if (query.includes('=')) {
    const params = new URLSearchParams(query)
    return params.get('invited_code') || null
  }

  return query
}
const invitedCode = getCodeFromUrl(redirect)
const forceLogout = () => {
  const defaultUrl = `/${route.path?.split('/')[1]}/lobby`
  if (!((getCookie(PATH[`${path}`].header) && getCookie(PATH[`${path}`].pathName)) || getCookie(`${PATH[`${path}`].path}-required-two-factor`) === 'true')) {
    if (route.query?.invited_code || redirect?.includes('/alumni/register_alumnus_community')) {
      router.push(`/alumni/invited_communities/alumni/${invitedCode || route.query?.invited_code}`)
    } else {
      router.push({
        path: `/${path}${path === 'community' ? '/users' : ''}/login`,
        query: {
          redirect: redirect ?? defaultUrl,
        },
      })
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SD40editCompleted')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeValid && _ctx.removeValid(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('SD40editCompletedMess')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              id: "btnForceLogout",
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})